/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Walk_InInputs */

const vi_customer_walk_in = /** @type {(inputs: Customer_Walk_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách lẻ`)
};

/**

* @param {Customer_Walk_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_walk_in = /** @type {((inputs?: Customer_Walk_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Walk_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_walk_in(inputs)
});